import {Routes, Route} from 'react-router-dom'
import ReportsSelector from './ReportsSelector'
import NDVIReport from './NDVIReport'
import TechnicalReport from './TechnicalReport'
import EconomicReport from './EconomicReport'
import './ReportsMobile.scss'

export const LeftContainerReports = () => {
  return (
    <Routes>
      <Route index element={<ReportsSelector />} />
      <Route path='ndvi/*' element={<NDVIReport />} />
      <Route path='technical/*' element={<TechnicalReport />} />
      <Route path='economic/*' element={<EconomicReport />} />
    </Routes>
  )
}
